<template>
  <div class="main">
    <div class="breadcrumb">
      <a-breadcrumb>
        <a-breadcrumb-item style="font-size: 16px">
          <router-link :to="'/books/studyTask'">学习任务</router-link>
        </a-breadcrumb-item>
        <a-breadcrumb-item style="font-size: 16px">备课资源</a-breadcrumb-item>
      </a-breadcrumb>
      <TopBack :type="studyTask" :select="studySelect" v-show="false"></TopBack>
    </div>
    <div class="content">
      <a-tabs default-active-key="1" @change="callback">
        <a-tab-pane key="1" tab="系统资源">
          <div class="list">
            <ul class="h-ul" v-if="listData.length>0">
              <li class="h-li" v-for="(item,index) in listData" :key="index">
                <!--              <div class="gray" v-if="index!==0"></div>-->
                <div style="padding: 20px;">
                  <div class="title_sys">
                    <div class="left">
                      <img class="img" :src="item.userPhoto==null?'./imgs/syzg_logo.png':''" alt="">
                      <span class="time">{{ item.userName || '素养植根专家团队' }} </span>
                      <span class="class-name">{{ item.schoolName }}</span>
                    </div>
                    <!-- <div>已被使用36次</div> -->
                    <div class="right" @click="useStudyRecommand(item,1)">使用</div>
                  </div>
                  <div class="s-t" v-html="item.content"></div>
                  <ul class="act-ul" v-if="item.activityList&&item.activityList.length>0">
                    <li class="act-li" v-for="(a,ai) in item.activityList" :key="ai">
                      <div class="l">活动{{ format.number2Text(ai) }}</div>
                      <!-- <div class="c">[{{format.taskStyle(a.activityStyle)}}]</div> -->
                      <!--                    <div class="r" v-html="a.activityContent"></div>-->
                      <rich-text-view
                          :key="new Date().getTime()"
                          class="r"
                          :content='a&&a.activityContent'
                          :images="a.imageList||[]"
                          :videos="a.videoList||[]"
                          :audios="a.audioList||[]"
                      ></rich-text-view>
                    </li>
                  </ul>
                </div>
              </li>
            </ul>
            <a-empty style="margin-top: 150px;" v-if="listData.length===0"></a-empty>
          </div>

          <div v-if="listData.length!==0" style="text-align:center;margin:15px 0px;">
            <a-config-provider>
              <a-pagination :default-current="1" :page-size="pageSize" @change="handleListChange" :total='total'/>
            </a-config-provider>
          </div>
        </a-tab-pane>
        <a-tab-pane key="2" tab="优质资源" force-render>
          <div class="list">
            <ul class="h-ul" v-if="listDatas.length>0">
              <li class="h-li" v-for="(item,index) in listDatas" :key="index">
                <div class="gray" v-if="index!==0"></div>
                <div style="padding: 20px;">
                  <div class="title">
                    <div class="left">
                      <img class="img" :src="item.userPhoto==null?'./imgs/teacher.png':''" alt="">
                      <span class="time">{{ item.name || '素养植根团队' }} </span>
                      <span class="class-name">{{ item.schoolName }}</span>
                    </div>
                    <!-- <div>已被使用36次</div> -->
                    <div class="right" @click="useStudyRecommand(item,2)">使用</div>
                  </div>
                  <div class="s-t" v-html="item.content"></div>
                  <ul class="act-ul" v-if="item.activityList&&item.activityList.length>0">
                    <li class="act-li" v-for="(a,ai) in item.activityList" :key="ai">
                      <div class="l">活动{{ format.number2Text(ai) }}</div>
                      <!-- <div class="c">[{{format.taskStyle(a.activityStyle)}}]</div> -->
                      <!--                    <div class="r" v-html="a.activityContent"></div>-->
                      <rich-text-view
                          :key="new Date().getTime()"
                          class="r"
                          :content='a&&a.activityContent'
                          :images="a.imageList||[]"
                          :videos="a.videoList||[]"
                          :audios="a.audioList||[]"
                      ></rich-text-view>
                    </li>
                  </ul>
                </div>
              </li>
            </ul>
            <a-empty style="margin-top: 150px;" v-if="listDatas.length===0"></a-empty>
          </div>
          <div v-if="listDatas.length!==0" style="text-align:center;margin:15px 0px;">
            <a-config-provider>
              <a-pagination :default-current="1" :page-size="pageSize" @change="handleListChange" :total='total'/>
            </a-config-provider>
          </div>
        </a-tab-pane>
        <a-tab-pane key="3" tab="用户资源">
          <div class="list">
            <ul class="h-ul" v-if="listData_use.length>0">
              <li class="h-li" v-for="(item,index) in listData_use" :key="index">
                <div class="gray" v-if="index!==0"></div>
                <div style="padding: 20px;">
                  <div class="title">
                    <div class="left">
                      <img class="img" :src="item.userPhoto==null?'./imgs/teacher.png':''" alt="">
                      <span class="time">{{ item.name || '素养植根团队' }} </span>
                      <span class="class-name">{{ item.schoolName }}</span>
                    </div>
                    <!-- <div>已被使用36次</div> -->
                    <div class="right" @click="useStudyRecommand(item,3)">使用</div>
                  </div>
                  <div class="s-t" v-html="item.content"></div>
                  <ul class="act-ul" v-if="item.activityList&&item.activityList.length>0">
                    <li class="act-li" v-for="(a,ai) in item.activityList" :key="ai">
                      <div class="l">活动{{ format.number2Text(ai) }}</div>
                      <!-- <div class="c">[{{format.taskStyle(a.activityStyle)}}]</div> -->
                      <!--                    <span class="r" v-html="a.activityContent"></span>-->
                      <rich-text-view
                          :key="new Date().getTime()"
                          class="r"
                          :content='a&&a.activityContent'
                          :images="a.imageList||[]"
                          :videos="a.videoList||[]"
                          :audios="a.audioList||[]"
                      ></rich-text-view>
                    </li>
                  </ul>
                </div>
              </li>
            </ul>
            <a-empty style="margin-top: 150px;" v-if="listData_use.length===0"></a-empty>
          </div>

          <div v-if="listData_use.length!==0" style="text-align:center;margin:15px 0px;">
            <a-config-provider>
              <a-pagination :default-current="1" :page-size="pageSize" @change="handleListChange" :total='total'/>
            </a-config-provider>
          </div>
        </a-tab-pane>
      </a-tabs>

    </div>
  </div>
</template>

<script>
// import HanIcon from 'components/Icon.vue'
import format from '../../../../utils/format.js'
import TopBack from '../../../../components/TopBack.vue'
import RichTextView from '../../../../components/richTextView.vue'
import requestUrl from '@/utils/requestUrl.js'

export default {
  name: 'ZiYuanTuiJian',
  data () {
    return {
      format,
      loading: false,
      total: 0,
      pageSize: 10,
      pageNum: 1,
      recommendType: 1,
      listData: [],
      listDatas: [],
      listData_use: [],
      indexNum: '',
      studyTask: {
        name: '学习任务',
        route: 'StudyTask'
      },
      studySelect: {
        name: '备课资源',
        route: 'StudyTaskRecommend'
      },
      styleId: localStorage.getItem('styleId'),
      bookId: localStorage.getItem('syzg-bookId'),
      userId: this.$getUserInfo().id,
      access_token: this.$getUserInfo().access_token
    }
  },
  components: {
    TopBack,
    RichTextView
  },

  watch: {
    mlVisible () {

    }
  },
  mounted () {
    this.getList()
    // this.getLists()
    // this.getLists_use()
  },
  methods: {
    goBack () {
      this.$router.go(-1)
    },
    callback (key) {
      this.recommendType = key
      switch (key) {
        case '1':
          this.getList()
          break
        case '2':
          this.getLists()
          break
        case '3':
          this.getLists_use()
          break
      }
    },
    handleListChange (current, pageSize) {
      this.pageNum = current
      this.pageSize = pageSize
      if (this.recommendType === '1') {
        this.getList()
      } else if (this.recommendType === '2') {
        this.getLists()
      } else {
        this.getLists_use()
      }
    },
    getList (index) { // 资源列表--系统资源
      const param = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        bookId: this.bookId,
        styleId: this.styleId,
        recommendType: 1,
        access_token: this.access_token
      }
      this.$http.post(requestUrl.getRecommendTask, param).then(res => {
        this.listData = res.list.map((item, index) => ({ ...item, index }))
        this.listData.forEach(item => {
          item.selected = true
          if (item.index == index) {
            item.selected = false
          }
        })
        this.total = res.total
      })
    },
    getLists (index) { // 资源列表--优质资源
      const param = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        bookId: this.bookId,
        styleId: this.styleId,
        recommendType: 3,
        access_token: this.access_token
      }
      this.$http.post(requestUrl.getRecommendTask, param).then(res => {
        this.listDatas = res.list.map((item, index) => ({ ...item, index }))
        this.listDatas.forEach(item => {
          item.selected = true
          if (item.index == index) {
            item.selected = false
          }
        })
        this.total = res.total
      })
    },
    getLists_use (index) { // 资源列表--用户资源
      const param = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        bookId: this.bookId,
        styleId: this.styleId,
        recommendType: 2,
        access_token: this.access_token
      }
      this.$http.post(requestUrl.getRecommendTask, param).then(res => {
        this.listData_use = res.list.map((item, index) => ({ ...item, index }))
        this.listData_use.forEach(item => {
          item.selected = true
          if (item.index == index) {
            item.selected = false
          }
        })
        this.total = res.total
      })
    },
    useStudyRecommand (item, type) {
      // 使用
      console.log(item)
      if (item.activityList === null || item.activityList.length < 0) {
        this.$message.success('该任务下没有活动')
        return
      }
      this.indexNum = item.index
      const param = {
        id: item.id,
        teacherId: this.userId,
        styleId: this.styleId,
        recommendType: type,
        access_token: this.access_token
      }
      this.$http.post(requestUrl.useRecommendTask, param).then(res => {
        if (res) {
          this.$message.success('使用成功')
          this.$router.push({ name: 'StudyTask' })
          // this.getList(item.index)
          // this.getLists(item.index)
          // this.getLists_use(item.index)
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
ul, li {
  list-style: none;
  margin: 0;
  padding: 0;
}

.sysRec {
  color: @primary-color;
  font-size: 14px;
  margin-right: 10px;
}

.main {
  margin-left: -205px;

  .breadcrumb {
    width: 1240px;
    margin: 0px auto 20px auto;
  }

  .top {
    height: 60px;
    background: @primary-color;
    display: flex;
    line-height: 60px;
    align-items: center;
    padding: 0 50px;

    .img {
      width: 20px;
      height: 20px;
      margin-top: 4px;
      cursor: pointer;
    }

    .text {
      font-size: 16px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #fff;
      margin-left: 10px;
      line-height: 30px;
      cursor: pointer;
    }

    .zb {
      cursor: pointer;
    }

    .zy {
      cursor: pointer;
    }
  }

  .content {
    min-height: 600px;
    background: #fff;
    width: 1240px;
    margin: 0 auto;
    margin-top: 20px;
    margin-bottom: 50px;
    border-radius: 8px;
    height: calc(100vh - 185px);

    .list {
      overflow-y: auto;
      overflow-x: hidden;
      height: calc(100vh - 300px);
    }

    .name,
    .className,
    .useNum,
    .useTo {
      letter-spacing: 0px;
      color: #9d9292;
      font-size: 14px;

      img {
        width: 40px;
        height: auto;
      }
    }

    .className {
      margin-left: 10px;
    }

    .useTo {
      display: inline-block;
      width: 80px;
      height: 30px;
      background-color: @primary-color;
      color: #fff;
      margin-left: 20px;
    }

    .useTo1 {
      display: inline-block;
      width: 80px;
      height: 30px;
      background-color: @primary-color;
      color: #fff;
      margin-left: 20px;
    }

    .avatar {
      width: 25px;
      height: 25px;
    }

    .contentMes {
      font-family: PingFangSC-Regular;
      font-size: 18px;
      font-weight: normal;
      font-stretch: normal;
      letter-spacing: 0px;
      color: #040506;
    }

    .ulList {
      padding: 0;
      margin-top: 10px;
      list-style: none;

      .listMes {
        font-family: PingFangSC-Regular;
        font-size: 16px;
        font-weight: normal;
        font-stretch: normal;
        letter-spacing: 0px;
        color: #9d9292;

        p {
          img {
            width: 16px;
            height: 16px;
            margin-top: -2px;
            display: inline-block;
            margin-right: 10px;
          }

          display: inline-block;
        }
      }
    }
  }
}

.h-ul {
  width: 1240px;
  min-height: 500px;
  margin: 0 auto;
  background: #fff;

  .h-li {
    // width: 1240px;
    // min-height: 226px;

    border-radius: 4px;
    background: #F1F0F0;
    margin: 25px;
    border-radius: 6px;

    .gray {
      width: 100%;
      height: 20px;
      background: #F1F0F0;
    }

    .title_sys {
      display: flex;

      .left {
        color: #867D7B;
        font-size: 16px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        width: calc(100% - 120px);
        display: flex;
        align-items: center;

        .img {
          width: 32px;
          height: 42px;
        }

        .time {
          margin-left: 12px;
        }

        .class-name {
          margin-left: 12px;
        }
      }

      .right {
        width: 80px;
        height: 24px;
        background: @primary-color;
        border-radius: 2px;
        line-height: 24px;
        color: #fff;
        text-align: center;
        margin-left: auto;
        cursor: pointer;
      }
    }

    .title {
      display: flex;

      .left {
        color: #867D7B;
        font-size: 16px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        width: calc(100% - 120px);
        display: flex;
        align-items: center;

        .img {
          width: 32px;
          height: 32px;
        }

        .time {
        }

        .class-name {
          margin-left: 12px;
        }
      }

      .right {
        width: 80px;
        height: 24px;
        background: @primary-color;
        border-radius: 2px;
        line-height: 24px;
        color: #fff;
        text-align: center;
        margin-left: auto;
        cursor: pointer;
      }
    }

    .s-t {
      color: #000;
      margin: 10px 0;
      font-size: 16px;
      width: 100%;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .act-ul {
      .act-li {
        display: flex;
        font-size: 14px;
        font-weight: 400;
        margin-top: 12px;

        .l {
          color: #867D7B;
          width: 42px;
        }

        .c {
          color: @primary-color;
          width: 42px;
          margin-left: 15px;
        }

        .r {
          color: #666;
          font-size: 14px;
          margin-left: 10px;
          flex: 1;
        }
      }
    }
  }
}

/deep/ .ant-list-pagination {
  text-align: center;
  padding-bottom: 20px;
  margin-bottom: 10px;
}

/deep/ .ant-list-vertical .ant-list-item-meta {
  margin-bottom: 0px;
}

/deep/ .ant-list-split .ant-list-item {
  border-bottom: 15px solid #f1f0f0;
  padding: 20px 30px 20px 30px;
}

/deep/ .ant-list-something-after-last-item
.ant-spin-container
> .ant-list-items
> .ant-list-item:last-child {
  border-bottom: 15px solid #f1f0f0;
}

/deep/ .ant-carousel {
  text-align: center;
  width: 900px;
  margin: auto;
  overflow: hidden;
}

/deep/ .ant-tabs-bar {
  margin: 0;
}

/* table 样式 */
/deep/ table {
  border: 1px solid #ccc !important;
}

/deep/ th {
  border: 1px solid #ccc !important;
  min-height: 30px;
  height: 30px;
  text-align: center;
  background: #f3f1f2;
}

/deep/ td {
  border: 1px solid #ccc !important;
  min-height: 30px;
  height: 30px;
  text-align: center;
}
</style>
